import { render } from "./phone-bar.vue?vue&type=template&id=6ca2c92a&scoped=true"
import script from "./phone-bar.vue?vue&type=script&lang=js"
export * from "./phone-bar.vue?vue&type=script&lang=js"

import "./phone-bar.vue?vue&type=style&index=0&id=6ca2c92a&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca2c92a"]])

export default __exports__